<script lang="ts" setup>
import { TuiEmptyState } from '@clickbar/tailwindui-vue'

import { PRODUCTS_KEY, type PageElementOfType } from '../page-builder'
import ProductGridItem from '@/components/Tenant/Product/ProductGridItem.vue'

const props = defineProps<{
  element: PageElementOfType<'product'>
}>()

const allProducts = inject(PRODUCTS_KEY)!
const selectedProduct = computed(() =>
  allProducts.value.find((product) => product.id === props.element.data.productId),
)
</script>

<template>
  <div>
    <TuiEmptyState
      v-if="element.data.productId === null"
      title="Kein Produkt ausgewählt."
      class="!py-4"
    >
      <template #icon="iconProps">
        <IMaterialSymbolsErrorOutline v-bind="iconProps" />
      </template>
    </TuiEmptyState>

    <template v-else>
      <TuiEmptyState v-if="!selectedProduct" title="Ticket nicht gefunden." class="!py-4">
        <template #icon="iconProps">
          <ICarbonNoTicket v-bind="iconProps" />
        </template>
      </TuiEmptyState>

      <div v-else class="pointer-events-none">
        <ProductGridItem :product="selectedProduct" />
      </div>
    </template>
  </div>
</template>
